import React from 'react'

import BootcampStartNotification from '../../components/BootcampStartNotification'
import SectionLayout from '../../components/SectionLayout'
import { useGenerateApplyNowLink } from '../../components/useGenerateApplyNowLink'
import { bootcampsData, BootcampsType } from '../../data/bootcampsData'

const BootcampStartNotificationSection = ({
  type
}: {
  type: BootcampsType
}) => {
  const to = useGenerateApplyNowLink(type)
  return (
    <SectionLayout className="bg-primary-dark py-10">
      <BootcampStartNotification
        to={to}
        start_date={bootcampsData[type].starting}
        duration={bootcampsData[type].duration}
      />
    </SectionLayout>
  )
}

export default BootcampStartNotificationSection
